import React, { useState } from "react";

const Icon = ({ selected, onClick, normalSVG, activeSVG, inactiveSVG }) => {
  const [hover, setHover] = useState(false);

  return (
    <div className="icon" onClick={onClick} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      {selected ? activeSVG : hover ? normalSVG : inactiveSVG}
    </div>
  );
};

export default Icon;
